export default __webpack_public_path__ + "static/media/Spray 3.22322863.png";